/**
 * EMZI NEXUS — Standardized Status Badge Component
 * Consistent status display across all supervisor and submission views
 */

import React from 'react';
import { getStatusColor } from '../../constants/statusConstants';

const StatusBadge = ({ status, size = 'sm', showDot = true }) => {
  const c = getStatusColor(status);

  const sizeStyles = {
    xs: { fontSize: '10px', padding: '2px 6px', gap: '4px', dotSize: '5px' },
    sm: { fontSize: '12px', padding: '4px 10px', gap: '6px', dotSize: '6px' },
    md: { fontSize: '13px', padding: '5px 12px', gap: '6px', dotSize: '7px' },
    lg: { fontSize: '14px', padding: '6px 14px', gap: '8px', dotSize: '8px' }
  };

  const s = sizeStyles[size] || sizeStyles.sm;

  return (
    <span
      data-testid={`status-badge-${status}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        padding: s.padding,
        borderRadius: '12px',
        fontSize: s.fontSize,
        fontWeight: 600,
        background: c.bg,
        color: c.text,
        border: `1px solid ${c.border}`,
        whiteSpace: 'nowrap',
        lineHeight: 1.2
      }}
    >
      {showDot && (
        <span style={{
          width: s.dotSize,
          height: s.dotSize,
          borderRadius: '50%',
          background: c.dot,
          flexShrink: 0
        }} />
      )}
      {c.label}
    </span>
  );
};

export default StatusBadge;
